import { jsxs as d, jsx as o } from "react/jsx-runtime";
import { Button as s } from "../../shared/button/Button.component.js";
import { ButtonThemeEnum as c } from "../../shared/button/types.js";
import { Input as f } from "../../shared/input/Input.component.js";
import { useState as h, useCallback as a } from "react";
import { S as w } from "../../plus-icon-BolIHS6e.js";
import { InputSizeEnum as I, InputThemeEnum as N } from "../../shared/input/types.js";
import '../../assets/StepParamsNewFieldInput.css';const _ = "_newFieldInput_1ixgp_2", g = "_input_1ixgp_7", y = "_addButton_1ixgp_10", i = {
  newFieldInput: _,
  input: g,
  addButton: y
}, b = ({
  onAddField: p,
  copies: u
}) => {
  const [t, m] = h(""), n = a(
    (e) => {
      e.preventDefault(), e.stopPropagation(), t && (p(t), m(""));
    },
    [t, p]
  ), r = a(
    (e) => {
      m(e.target.value);
    },
    []
  ), l = a(
    (e) => {
      e.key === "Enter" && n(e);
    },
    [n]
  );
  return /* @__PURE__ */ d("div", { className: i.newFieldInput, children: [
    /* @__PURE__ */ o(
      f,
      {
        type: "text",
        placeholder: "New field name",
        value: t,
        onChange: r,
        className: i.input,
        inputTheme: N.secondary,
        inputSize: I.md,
        onKeyDown: l
      }
    ),
    /* @__PURE__ */ o(
      s,
      {
        type: "submit",
        theme: c.primary,
        onClick: n,
        "aria-label": u.addField,
        className: i.addButton,
        children: /* @__PURE__ */ o(w, {})
      }
    )
  ] });
};
export {
  b as StepParamsNewFieldInput
};
